import store from '@/store/store'

export default function useValidation() {
  // region Methods
  const validationStatuses = (validation, enableDirtyClass = true) => {
    return {
      error: validation.$error,
      dirty: enableDirtyClass ? validation.$dirty : false
    }
  }

  const validationErrorNotification = () => {
    const notifications = {
      type: 'danger',
      message: t('shared.validations.error')
    }
    store.dispatch('notification/add', notifications, {
      root: true
    })
  }
  // endregion

  return { validationStatuses, validationErrorNotification }
}
